import {useEffect, useRef, useState} from "react";
import React from 'react';
import {productsAPI} from "../../../api/api";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import styles from "./ProductCardNew.module.css"
import _ from "lodash";
import {Image, Spinner} from "react-bootstrap";
import {SpinnerUA} from "../../../common/Spinners/SpinerUA/SpinnerUA";
import "./../../../common/Layout/modal.css"
import "../CatalogProduct.css"
import "primereact/resources/primereact.min.css";//core css
import {Galleria} from "primereact/galleria";
import noPhoto from "../../../common/image/no photo stub.jpg";
import {Button} from "primereact/button";
import {useWindowDimensions} from "../../../Context/WindowDimensionsContext";
import {ProductBalance} from "../../../common/constants"


export const ProductCardNew = ({id, price, number, articleList,  addToCart, setShow, balance, deliveryDate}) => {

    const galleria = useRef(null);
    const imageInfoWrapper = useRef(null);
    const secondWrapper = useRef(null);
    const [isLoading, setIsLoading] = useState(true);

    const [stringPrice, setStringPrice] = useState("");

    const [imageUrlList, setImageUrlList] = useState("");
    const [productInfo, setProductInfo] = useState("");

    const [oilViscosity, setOilViscosity] = useState("")
    const [oilType, setOilType] = useState("")
    const [equipmentCategory, setEquipmentCategory] = useState("")
    const [productCategory, setProductCategory] = useState("")
    const [engineTypes, setEngineTypes] = useState([])


    const [description, setDescription] = useState([]);
    const [otherFilters, setOtherFilters] = useState([]);

    const [specifications, setSpecifications] = useState([]);
    const [specificationKeys, setSpecificationKeys] = useState([]);

    const [admittances, setAdmittance] = useState([]);
    const [admittanceKeys, setAdmittanceKeys] = useState([]);

    const [presentDiv, setPresentDiv] = useState(<div></div>);
    const {viewPortWidth,viewPortHeight} = useWindowDimensions();

    const [buyProductButton, setBuyProductButton] = useState(<Button/>)
    //balance
    const [productBalanceStatus, setProductBalanceStatus] = useState(ProductBalance.InStock)

    const addToCartHandler = () => {
        addToCart();
        setShow(false);
    }

    useEffect(() => {
        let icon = '';
        let color = '';
        let textStatus = ''
        let status = null;
        let prodButton = (<Button label="В кошик" style={{ fontFamily:'Commissioner', fontWeight:'500', color:'#404040', borderRadius:'10px' }} onClick={addToCartHandler} className={styles.buyButton}/>)
    
        // Определяем статус и параметры иконки и кнопки на основе balance и даты поставки
        if (balance === 0) {
            status = ProductBalance.OutOfStock;
            icon = 'pi pi-clock';
            textStatus = 'Немає в наявності'
            color = '#dc3545';
            if(deliveryDate){
                prodButton = (<Button label="Очікуємо поставки..." disabled={true} style={{ fontFamily:'Commissioner', fontWeight:'500', color:'#404040', borderRadius:'10px' }} className={styles.buyButton}/>)
            }else{
                prodButton = (null)
            }
        } else if (balance >= 6) {
            status = ProductBalance.Ends;
            textStatus = 'В наявності'
            icon = 'pi pi-verified';
            color = '#28a745';
        } else if (balance < 6) {
            status = ProductBalance.InStock;
            textStatus = 'Закінчується'
            icon = 'pi pi-clock';
            color = '#ff9800';
        }

        setProductBalanceStatus(status);
        setPresentDiv(<h4 style={{ color: color}}>{textStatus}</h4>);
        setBuyProductButton(prodButton)

    }, [balance, viewPortWidth]);

    useEffect(() => {
        setStringPrice((parseFloat(price)).toLocaleString('uk-UA', { style: 'currency', currency: 'UAH',}))
    }, [price])

    const groupProductFilters = (filters) => {
        //вязкость
        if (filters.OilViscosities.length !== 0) {
            setOilViscosity(filters.OilViscosities[0].Name);
        }
        //тип масла
        if (filters.OilTypes.length !== 0) {
            setOilType(filters.OilTypes[0].Name);
        }
        //категория техники
        if (filters.EquipmentСategories.length !== 0) {
            setEquipmentCategory(filters.EquipmentСategories[0].Name);
        }
        //категория товара
        if (filters.ProductСategories.length !== 0) {
            setProductCategory(filters.ProductСategories[0].Name);
        }

        if (filters.EngineTypes.length !== 0) {
            setEngineTypes(filters.EngineTypes);
        }

        if (filters.Admittances.length > 0) {
            try {
                const grouped = _.groupBy(filters.Admittances, 'AdmittanceName');
                const keys = _.keys(grouped);
                setAdmittance(grouped);
                setAdmittanceKeys(keys);
            } catch (err) {
                console.log(err)
            }
        }

        if (filters.Specifications.length > 0) {
            try {
                const grouped = _.groupBy(filters.Specifications, 'SpecificationName');
                const keys = _.keys(grouped);
                setSpecifications(grouped);
                setSpecificationKeys(keys);
            } catch (err) {
                console.log(err)
            }
        }

    }

    const fetchProductInfo = async (id) => {
        setIsLoading(true);
        const {data} = await productsAPI.getProductInfo(id)
        let resp = JSON.parse(data);
        if (resp.isSucccess) {
            setProductInfo(resp.data.ProductFilters);
            setDescription(resp.data.ProductDescription)
            if(resp.data.OriginalImageUrls.length){
                setImageUrlList(resp.data.OriginalImageUrls)
            }
            else{
                setImageUrlList([noPhoto])
            }

            groupProductFilters(resp.data.ProductFilters);
            setIsLoading(false);
        }

    }

    useEffect(() => {
        fetchProductInfo(id).then();
    }, [id])

    useEffect(() => {
        let url = window.location.pathname;

    },[])

    const responsiveOptions = [
        {
            breakpoint: '991px',
            numVisible: 4
        },
        {
            breakpoint: '767px',
            numVisible: 3
        },
        {
            breakpoint: '800px',
            numVisible: 1
        }
    ];



    const itemTemplate = (item) => {
        return <Image src={item}  style={{display: 'block', maxHeight: '95vh' }} />
    }

    const thumbnailTemplate = (item) => {
        return  <Image src={"data:image/jpeg;base64,"+item}  width="100px"  />
    }

    if (isLoading) {
        return (
            <SpinnerUA />
        )
    }

    return (
        <div className={`${styles.productCard}`}>

            {viewPortWidth > 1023 && <Galleria  ref={galleria} value={imageUrlList} responsiveOptions={responsiveOptions}
                       style={{ marginRight: '1rem', borderRadius: '1rem', backgroundColor: '#fff' }}
                       item={itemTemplate} fullScreen circular  showItemNavigators showItemNavigatorsOnHover showIndicators showIndicatorsOnItem={true}   showThumbnails={false} />}

            <div ref={imageInfoWrapper} className={styles.imageInfoWrapper} id='imageInfoWrapper'>
                <div className={styles.imageIcon}>
                    <Image className={styles.image}  src={imageUrlList[0]} onClick={() => galleria.current.show()} />
                </div>
                <div className={styles.info} >

                    <div className={styles.productFunction}>
                        <div className={styles.present}>
                            {presentDiv}
                        </div>
                        <h4 className={styles.price}>{stringPrice}</h4>
                        {buyProductButton}
                    </div>

                    <div className={styles.descriptionWrapper}>
                        <div className={styles.descriptionTitle}>Опис</div>
                        <div dangerouslySetInnerHTML={{ __html: description }} className={styles.descriptionText}></div>
                    </div>

                    <div className={styles.mainSettings}>
                        {productCategory && <div className={styles.filterBlock}>
                            Категорія товару: <span className={styles.filterSpan}>{productCategory}</span>
                        </div>}

                        {oilViscosity !== "" ?
                            <div className={styles.filterBlock}>
                                В'язкість: <span className={styles.filterSpan}>{oilViscosity}</span>
                            </div> : null}

                        {oilType !== "" ? <div className={styles.filterBlock}>

                            Тип оливи: <span className={styles.filterSpan}>{oilType}</span>
                        </div> : null}

                        {equipmentCategory && <div className={styles.filterBlock}>
                            Категорія техніки: <span className={styles.filterSpan}>{equipmentCategory}</span>
                        </div>}

                        {articleList?.length && <div className={styles.filterBlock}>
                            Артикул Shell: <span className={styles.filterSpan}>{articleList[0]}</span>
                        </div>}

                         {articleList?.length > 1 && <div className={`${styles.filterBlock} ${styles.opacity}`}>
                            Архівні артикули Shell : <span className={styles.filterSpan}>{articleList.slice(1).join(', ')}</span>
                        </div>}
                    </div>

                </div>

            </div>
            <div ref={secondWrapper} className={styles.secondSettingsWrapper} id='secondWrapper'>

                <div className={styles.specificationsWrapper}>
                    <div className={styles.specificationsTitle}>Спеціфікації</div>
                    {specificationKeys.length > 0 ?
                        <div className={styles.filterBlock}>
                            {specificationKeys.map((key, index) =>
                                <div key={key + index}
                                     className={styles.admittance}>{key}: <ul> {specifications[key.toString()].map((specification, index) =>
                                    <li key={specification + index}>{specification.SpecificationValue + "; "}</li>)}
                                </ul>
                                </div>)}
                        </div> : null}
                </div>

                <div className={styles.admittancesWrapper}>
                    <div className={styles.admittancesTitle}>Допуски</div>
                    {admittanceKeys.length > 0 ? <div className={styles.filterBlock}>
                        {admittanceKeys.map((key, index) =>
                            <div key={key + index}
                                 className={styles.admittance}>{key}: <ul> {admittances[key.toString()].map((admittance, index) =>
                                <li key={admittance + index}>{admittance.AdmittanceValue + "; "}</li>)}
                            </ul>
                            </div>)}
                    </div> : null}
                </div>

            </div>
        </div>
    )
}